<template>
  <loading v-if="isAccepted"></loading>
  <error
    v-else-if="isNotFound"
    :errorTitle="$t('error.notFound.title')"
    :displayPrimaryErrorButton="true"
    @primaryErrorButtonFunction="redirectToPages"
    :primaryErrorButtonText="$t('error.notFound.buttons.home')"
    :displaySecondaryErrorButton="false"
  ></error>
  <error
    v-else-if="isUnprocessableEntity"
    :errorTitle="$t('error.metricsProcess.title')"
    :errorSubtitle="$t('error.metricsProcess.subtitle')"
    :displayPrimaryErrorButton="true"
    @primaryErrorButtonFunction="primaryErrorButtonFunction"
    :primaryErrorButtonText="$t('error.metricsProcess.buttons.home')"
    :displaySecondaryErrorButton="true"
    @secondaryErrorButtonFunction="redirectToSupport"
    :secondaryErrorButtonText="$t('error.metricsProcess.buttons.support')"
  ></error>
</template>

<script>
import i18n from '@/i18n';
import { mapGetters } from 'vuex';
import Loading from './components/Loading';
import Error from './components/Error';
import rebrand from '../../config/rebrand';

export default {
  components: {
    Loading,
    Error,
  },
  data() {
    return {
      i18n,
      supportUrl: 'https://suporteklickpages.zendesk.com/hc/pt-br/requests/new',
      pagesUrl: rebrand.urls.KLICKART_URL.replace('http:', 'https:'),
    };
  },
  computed: mapGetters({
    isAccepted: 'status/isAccepted',
    isNotFound: 'status/isNotFound',
    isUnprocessableEntity: 'status/isUnprocessableEntity',
  }),
  methods: {
    redirectToSupport() {
      window.location = this.supportUrl;
    },
    redirectToPages() {
      window.location = this.pagesUrl;
    },
    primaryErrorButtonFunction() {
      this.$emit('primaryErrorButtonFunction');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Status/StatusMain.vue